module.exports = __webpack_public_path__ + "img/google play logo_new_transparent.f54c9bce.svg";